import styled from 'styled-components';
import ProductSidebarFooter from '../Products/ProductSidebar/ProductSidebarFooter';
import { ApplicationPageType } from '../AccountTabNav';
import AccountTabPage from '../Page/AccountTabPage';
import AuditSidebar from './AuditSidebar';
import AccountStage from '../AccountStage';
import AuditHistorySection from './Sections/AuditHistorySection';

const AuditPageNote = styled.p`${({ theme }) => `
  font-size: ${theme.fontSize[1]};
  font-style: italic;
  line-height: ${theme.fontSize[3]};
  margin-top: ${theme.padding[2]};
  margin-bottom: ${theme.padding[8]};
`}`;

export default function AuditPage() {
  return (
    <AccountTabPage
      page={ApplicationPageType.AUDIT}
      subHeader={<AccountStage />}
      sidebar={<AuditSidebar />}
      sidebarFooter={<ProductSidebarFooter />}
    >
      <AuditPageNote>Internal only page</AuditPageNote>
      <AuditHistorySection />
    </AccountTabPage>
  );
}
